var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.images && _vm.images.length)?_c('div',{staticClass:"grid-x grid-padding-x align-bottom"},_vm._l((_vm.images),function(img){return _c('div',{class:['cell', 'medium-'+img.imgtype]},[_c('prismic-image',{attrs:{"field":img.img}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }